import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(landing)/docs/page.tsx");
